import React from 'react';
import {WeaSearchGroup} from 'ecCom';
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import EType from './base/EType';
import ETitle from './base/ETitle';
import EShowNum from './base/EShowNum';
// import ELinkMode from './base/ELinkMode';
import DataSourceTable from './base/DataSourceTable';
import EShowHeader from "./base/EShowHeader";

// 公文中心
class Content_odocCenter extends React.Component {
    render() {
        const {hpid, eid, ebaseid, eShareLevel, synergyParams, subCompanyId} = this.props;
        let __DataSourceTable = <div></div>;
        if (eShareLevel == '2') {
            __DataSourceTable = <DataSourceTable ecId={`${this && this.props && this.props.ecId || ''}_DataSourceTable@kf4jos`} ref="dataSourceTable" hpid={hpid} eid={eid} subCompanyId={subCompanyId} ebaseid={ebaseid} {...this.props.eTabs} synergyParams={synergyParams}/>;
        }

        return (
            <div>
                <WeaSearchGroup ecId={`${this && this.props && this.props.ecId || ''}_WeaSearchGroup@olf40z`} title={getLabel(81711, '基本信息')} needTigger={true} showGroup={true}>
                    <EType ecId={`${this && this.props && this.props.ecId || ''}_EType@wz10pz`} ref="eType" value={this.props.eBaseName}/>
                    {this.props.eShareLevel == '2' ? <ETitle ecId={`${this && this.props && this.props.ecId || ''}_ETitle@nrzpii`} ref="eTitle" eid={this.props.eid} value={this.props.eTitle} {...this.props}/> : ''}
                    <EShowNum ecId={`${this && this.props && this.props.ecId || ''}_EShowNum@lpeix6`} ref="eShowNum" value={this.props.eShowNum}/>
                    {/* <ELinkMode ref="eLinkMode" options={this.props.eLinkMode.options} value={this.props.eLinkMode.selected} /> */}
                    <EShowHeader ecId={`${this && this.props && this.props.ecId || ''}_EShowHeader@njruns`} ref="eShowHeader" value={this.props.showHeader}/>
                </WeaSearchGroup>
                {__DataSourceTable}
            </div>
        );
    }

    getSaveValues() {
        return {
            eContentTitle: this.refs['eTitle'] ? this.refs['eTitle'].getSaveValues() : this.props.eTitle,
            eContentShowNum: this.refs['eShowNum'].getSaveValues(),
            // eContentLinkMode: this.refs['eLinkMode'].getSaveValues(),
            eContentTabWidth: { tabwidth: this.props.etabwidth, methodvalue: this.props.methodvalue },
            eContentShowHeader: this.refs['eShowHeader'].getSaveValues(),
            eContentIsAlwaysShow: this.props.isAlwaysShow,
            eContenteTabStyle: {tabstyle: this.props.tabstyle, tabvalue: this.props.tabvalue, tabname: this.props.tabname},
            eTabs: this.refs['dataSourceTable'] ? this.refs['dataSourceTable'].getSaveValues() : {}
        };
    }
}

export default Content_odocCenter;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/content/Content_odocCenter.js